import { Model } from "@vuex-orm/core";

export interface ticketTypeSettingEntity {
  ticketTypeSettingId: number;
  constraintType: number;
  defaultTicketTypeId: number | null;
  isEnabled: boolean;
}

export class ticketTypeSettingEntity extends Model {
  static entity = "ticketTypeSettingEntity";
  static primaryKey = "ticketTypeSettingId";
  static fields() {
    return {
      ticketTypeSettingId: this.number(0),
      constraintType: this.number(0),
      defaultTicketTypeId: this.attr(null),
      isEnabled: this.boolean(false),
    };
  }
}
